/**
 * Widget types offered to external HTML consumers, matched against the `data-hc-widget-type` attribute.
 *
 * The Giving Checkout, Campaign Details, Designation Details, Giving Opportunities, My Commitments, My Scheduled &
 * Recurring and Saved Payment Methods types were removed under AB#112440.  saddleback.com was swept for
 * `data-hc-widget-type` embeds first and none of the removed types were in use there.
 */
enum WidgetType {
    ConnectionForm = 'connection-form',
    GivingCampaignCommitment = 'giving-campaign-commitment',
    GivingHistory = 'giving-history',
    DigitalProgram = 'digital-program',
    DigitalProgramRock = 'digital-program-rock',
}

export default WidgetType;
